import React, { useEffect, useRef } from "react";
import { Reveal } from "./Reveal";

/**
 * Sections 4–6 — Asset bands. Full-bleed image with gentle background
 * parallax (~0.3 factor) and an overlaid eyebrow / heading / body.
 * Parallax disabled for prefers-reduced-motion.
 */
export const Band = ({ id, data, flip = false }) => {
  const sectionRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        const sec = sectionRef.current;
        const img = imgRef.current;
        if (!sec || !img) return;
        const rect = sec.getBoundingClientRect();
        const vh = window.innerHeight;
        // progress of section through viewport: -1 .. 1
        const prog = (rect.top + rect.height / 2 - vh / 2) / vh;
        img.style.transform = `translate3d(0, ${prog * 0.12 * vh}px, 0)`;
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <section
      id={id}
      ref={sectionRef}
      className={`mk-band ${flip ? "is-flip" : ""}`}
      data-testid={`band-${id}`}
    >
      {/* ASSET SLOT: band image ({id}) */}
      <div className="mk-band__media">
        <img ref={imgRef} src={data.asset} alt={data.alt} loading="lazy" />
      </div>
      <Reveal className="mk-band__content">
        <span className="mk-eyebrow" data-testid={`band-${id}-eyebrow`}>
          {data.eyebrow}
        </span>
        <h2 className="mk-band__heading" data-testid={`band-${id}-heading`}>
          {data.heading}
        </h2>
        <p className="mk-band__body">{data.body}</p>
      </Reveal>
    </section>
  );
};

export default Band;
